var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 91.5618,
    height: 91.5618,
    fill: "#EDF4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.9829 48.6417L58.2875 40.3603H50.2513V34.9773C50.2513 32.7129 51.3732 30.5002 54.9608 30.5002H58.6658V23.448C56.5082 23.1043 54.328 22.9183 52.1429 22.8916C45.5288 22.8916 41.2106 26.8641 41.2106 34.0457V40.3603H33.8789V48.6417H41.2106V68.6725H50.2513V48.6417H56.9829Z",
    fill: "#337FFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamFacebook);
export default __webpack_public_path__ + "static/media/teamFacebook.8777902c168149a56b7a5657734f589a.svg";
export { ForwardRef as ReactComponent };